module.exports = __webpack_public_path__ + "static/scoring-3-711f6046592e3f6b7267a074b4a973e8.svg";